import type { Theme } from '@mui/material/styles';

import { alpha } from '@mui/material/styles';

const Autocomplete = (theme: Theme) => {
  return {
    MuiAutocomplete: {
      styleOverrides: {
        listbox: {
          padding: theme.spacing(0, 1),
        },
        option: {
          ...theme.typography.body2,
          borderRadius: theme.shape.borderRadius,
          margin: theme.spacing(0.75, 0),
          padding: theme.spacing(1),
        },
        paper: {
          boxShadow: theme.customShadows.dropdown,
        },
        root: {
          '& span.MuiAutocomplete-tag': {
            ...theme.typography.body2,
            backgroundColor: alpha(theme.palette.grey[500], 0.16),
            borderRadius: theme.shape.borderRadius,
            height: 24,
            lineHeight: '24px',
            textAlign: 'center',
            width: 24,
          },
        },
      },
    },
  };
};

export default Autocomplete;
